export default __webpack_public_path__ + "station-defect-other-gray.png?e201411e314669b451d1a7900f6c49b5";